export function getFirstElement(input) {
  if (Array.isArray(input)) {
    // For arrays, find the first non-undefined element
    return input.find(element => element !== undefined);
  } else if (typeof input === 'object' && input !== null) {
    // For objects, return the value of the first key in the object
    const firstKey = Object.keys(input)[0];

    return input[firstKey];
  }

  return undefined;
}



// WEBPACK FOOTER //
// ./utils/getFirstElement.js